'use client';

import React from 'react';

import { BackToTopButton } from '@/components/animate';

export type LayoutSectionProps = React.ComponentProps<'div'> & {
  children?: React.ReactNode;
  footerSection?: React.ReactNode;
  headerSection?: React.ReactNode;
  sidebarSection?: React.ReactNode;
};

export function LayoutSection({
  children,
  footerSection,
  headerSection,
  sidebarSection,
  className,
  ...other
}: LayoutSectionProps) {
  return (
    <div className={`flex min-h-dvh flex-col ${className}`} {...other}>
      {sidebarSection ? (
        <>
          {sidebarSection}
          <div className="flex flex-col flex-1">
            {headerSection}
            {children}
            {footerSection}
          </div>
        </>
      ) : (
        <>
          {headerSection}
          {children}
          {footerSection}
        </>
      )}

      <BackToTopButton />
    </div>
  );
}
